import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import BackendApi from '../BackendApi';
import CookieStor from '../CookieStor'

import Header from '../components/Header';
import VideoInfo from '../components/VideoInfo'


class VideoInner extends Component {
  constructor(props){
    super(props);

    this.state = {
      item: {},
      videoLink: '',
      comments:[],
    };
  }

  componentDidMount(){
    let slug = this.props.location.pathname.split('/')[2]
    slug = slug ? slug : 'non'
		BackendApi.videoInfo(slug).then((result) => {
		  switch(result.status)
        {
          case 200:
            this.setState({
              item: result.data ? result.data : {},
              comments: result.data ? result.data.comments : {}
            });
            this.getVideo()
            break;
          
          case 401:
            CookieStor.setAccessToken('');
            CookieStor.setRefreshToken('');
            this.props.history.push('/');
            break;
          
          default:
            this.props.history.push('/');
            console.log('Ошибка сервера')
        }
    })   
  }

  getVideo = () => {
    let videoLink = this.state.item.video + '?access-token=' + CookieStor.getAccessToken();
    this.setState({videoLink: videoLink});
  }
  
  addComment = (comment) => {
    let slug = this.props.location.pathname.split('/')[2]
		BackendApi.addComment(slug, comment).then((result) => {
		  switch(result.status)
        {
          case 200:
            this.getComment()
            break;
          
          case 401:
            CookieStor.setAccessToken('');
            CookieStor.setRefreshToken('');
            this.props.history.push('/');
            break;
          
          default:
            console.log('Ошибка сервера')
        }
    })
  }

  getComment = () => {
    let slug = this.props.location.pathname.split('/')[2]
		BackendApi.commentList(slug).then((result) => {
      console.log(result.data.comments)
      this.setState({
        comments: result.data ? result.data : {}
      });
    })
  }
  
  render() {
    if (!CookieStor.getAccessToken()) {
      return <Redirect to='/'/>
    }

    return (
      <div className='page'>
        <Header />
        <VideoInfo info={this.state.item} videoLink={this.state.videoLink} comments={this.state.comments} addComment={this.addComment}/>
      </div>
    );
  }
}

export default VideoInner;
